import * as React from "react";
import { SVGProps } from "react";
export const TriangleForwardFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.04199 14.958C7.74999 15.1527 7.45132 15.1667 7.14599 15C6.84065 14.8333 6.68799 14.5693 6.68799 14.208V5.75C6.68799 5.38867 6.84065 5.12467 7.14599 4.958C7.45132 4.79133 7.74999 4.80533 8.04199 5L14.688 9.25C14.9653 9.41667 15.104 9.65967 15.104 9.979C15.104 10.2983 14.9653 10.5413 14.688 10.708L8.04199 14.958Z"
            fill="currentColor"
        />
    </svg>
);
TriangleForwardFillIcon.displayName = "TriangleForwardFillIcon";
